import React, { useState, useEffect } from "react";
import { Button, Container, Grid, FormControl, InputLabel, Select, MenuItem } from "@material-ui/core";
import HomePage from "../../Home";
import { VUsuariosStyle } from "./styles";
import TUsuarios from "./../TUsuarios";
import FUsuario from "./../FUsuarios";
import { useDispatch, useSelector } from "react-redux";
import { obtenerProveedoresUsuariosAllAction } from "../../../ducks/porveedorUsuarioDuck";
import BackDrop from "./../../../global/BackDrop";
import useApi from "./../../../hooks/useAPI";

export default function VProveedorUsuario() {
  const Clasess = VUsuariosStyle();
  const dispatch = useDispatch();
  const catalogoProveedores = useApi("Supplier/wholesaler");
  const proveedoresUsuarios = useSelector(
    (store) => store.proveedoresUsuarios.array
  );
  
  const [openModal, setOpenModal] = useState(false);
  const [rowTarget, setRowTarget] = useState({});
  const [editar, setEditar] = useState(false);
  const [isLoad, setIsLoad] = useState(false);
  const [idProveedor, setIdProveedor] = useState(0);
  useEffect(() => {
    setIsLoad(true);
    dispatch(obtenerProveedoresUsuariosAllAction(idProveedor)).then((Reposne) => {
      setIsLoad(false);
    });
  }, [dispatch, idProveedor]);
  const handleOpen = () => {
    setOpenModal(!openModal);
    setEditar(false);
  };
  const onEditar = (rowTarget) => {
    setRowTarget(rowTarget);
    setEditar(true);
    setOpenModal(!openModal);
  };
  const handleSelecProveedor = (event) =>{
    setIdProveedor(event.target.value);
  }
  return (
    <HomePage>
      <Container>
        <Grid
          container
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          className={Clasess.contentMargin}
        >
          <Grid item xs={3}>
          <FormControl variant="outlined" className={Clasess.formControl}>
              <InputLabel id="lTipoProveedor">Proveedor</InputLabel>
              <Select
                labelId="lTipoProveedor"
                id="STipoProveedor"
                name="proveedor"
                value={idProveedor}
                onChange={handleSelecProveedor}
                label="Proveedor"
              >
                <MenuItem value="0" disabled>
                  {"Seleccione una opción"}
                </MenuItem>
                {catalogoProveedores.map((item, index) => (
                  <MenuItem key={item.IdProveedor} value={item.IdProveedor}>
                    {item.RazonSocial}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={2} className={Clasess.flexEnd}>
            <Button variant="outlined" color="primary" onClick={handleOpen} disabled={(idProveedor > 0) ? false : true}>
              Nuevo usuario
            </Button>
          </Grid>
        </Grid>
        <Grid container>
          <Grid item xs={12}>
            <TUsuarios rows={proveedoresUsuarios} onEditar={onEditar} />
          </Grid>
        </Grid>
        <FUsuario
          open={openModal}
          setOpen={setOpenModal}
          editar={editar}
          setEditar={setEditar}
          rowData={rowTarget}
        />
        <BackDrop open={isLoad} />
      </Container>
    </HomePage>
  );
}
